module.exports = require('./helpers/bundle-url').getBundleURL('cTg1t') + "logo.c51670a8.svg";